import service from './service';

export const findAll = listQuery => {
  return service.get('/v1/order', listQuery);
};

export const findOne = id => {
  return service.get(`/v1/order/${id}`);
};

export const findOneSameAll = id => {
  return service.get(`/v1/order/one/${id}`);
};

export const findOrderReceipt = id => {
  return service.get(`/v1/order/${id}/receipt`);
};

export const update = (id, data) => {
  return service.post(`/v1/order/${id}`, data);
};

export const status = (id, status) => {
  return service.post(`/v1/order/${id}/status`, { status });
};

export const create = (order, orderDetail) => {
  return service.post(`/v1/order`, { order, orderDetail });
};

export const verify = id => {
  return service.post(`/v1/order/${id}/verify`);
};

export const sendEmail = id => {
  return service.post(`/v1/order/${id}/send`);
};

export const removeList = list => {
  return service.post(`/v1/order/deletes`, { list });
};

export const invoice = (invoiceSummary, invoiceProducts, orderId) => {
  return service.post(`/v1/order/invoice`, {
    invoiceSummary,
    invoiceProducts,
    orderId
  });
};
